
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reservations",
      function () {
        return require("private-next-pages/reservations/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reservations"])
      });
    }
  